export class DefaultCrateSaveError extends Error {
  constructor(message = 'Crate estimation save error') {
    super(message);
    this.name = 'CrateEstimationSaveError';
  }
}
